// extracted by mini-css-extract-plugin
export default {"productGrid":"K1-z","centerLink":"L1-z","productSection":"M1-z","item":"N1-z","ctaButton":"O1-z"};